import { Component, Inject } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { TrpcAPIService } from '../../trpc-api.service';

@Component({
  selector: 'auth-content',
  templateUrl: './auth-content.component.html',
  styles: `.login {
    --kendo-color-primary: var(--skov-secondary);

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100vh;
  }
  .login-btn {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: end;
    
  }
  `
})
export class AuthContentComponent {
  constructor(public auth: AuthService,@Inject('ServerApi') public apiService: TrpcAPIService) {}


}
